<section class="registration-section position-relative">
  <div class="registration-nav d-flex justify-content-between">
    <div class="logo-holder">
      <a href="#"><img src="/img/logo.png" alt="Telq" /></a>
    </div>
    <ul class="menu-holder d-flex align-items-center">
      <li><a [routerLink]="['/login']">Already have an account?</a></li>
      <li><a [routerLink]="['/login']" class="btn">Login</a></li>
    </ul>
  </div>

  <div class="registration-content container position-relative">
    <app-registration-form></app-registration-form>
  </div>

  <copyright-note></copyright-note>
</section>
